import React from 'react';
import { motion } from 'framer-motion';
import { ZoomIn } from 'lucide-react';

const IMAGES = [
  "https://i.imgur.com/so0uGgT.jpeg",
  "https://i.imgur.com/30VwUGo.jpeg",
  "https://i.imgur.com/cVY7RRS.jpeg",
  "https://i.imgur.com/sZnx6Ig.jpeg",
  "https://i.imgur.com/Xszm4te.jpeg",
  "https://i.imgur.com/JQ4t9mJ.jpeg"
];

const Gallery = () => {
  return (
    <section id="galerija" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-primary-orange font-bold tracking-wider uppercase mb-3">Galerija</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-neutral-darkNavy">Naši Radovi</h3>
          <div className="w-24 h-1 bg-primary-blue mx-auto mt-6 rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {IMAGES.map((src, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative aspect-[4/3] rounded-2xl overflow-hidden shadow-lg cursor-pointer"
            >
              <img 
                src={src} 
                alt={`Tip Top radovi ${index + 1}`} 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-primary-blue/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="text-center text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <ZoomIn size={32} className="mx-auto mb-2" />
                  <p className="font-bold text-lg">Tip Top Radovi</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
